class LogsConnect {
  constructor() {
    // Derive the backend server address from frontend URL
    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const host = window.location.hostname;
    
    // Use default ports for WebSocket (443 for secure, 80 for non-secure)
    // unless explicitly configured
    let port = '';
    if (process.env.VUE_APP_BACKEND_PORT) {
      port = `:${process.env.VUE_APP_BACKEND_PORT}`;
    }
    
    if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_BACKEND_SOCKET_URL) {
      // Explicit dev socket (serve / serve-local / serve-custom).
      const devPort = process.env.VUE_APP_BACKEND_PORT || 80;
      this.baseUrl = `${process.env.VUE_APP_BACKEND_SOCKET_URL}:${devPort}`;
    } else if (process.env.NODE_ENV === 'development') {
      // Gateway mode (serve-test): same-origin so the dev-server proxies the ws
      // (works from localhost and a LAN IP / phone).
      this.baseUrl = `${protocol}://${window.location.host}`;
    } else {
      // Production: current domain + configured port (unchanged).
      this.baseUrl = `${protocol}://${host}${port}`;
    }
  }

  // Get WebSocket URL for a specific endpoint
  getUrl(endpoint = '') {
    return `${this.baseUrl}${endpoint}`;
  }

  // Connect to WebSocket endpoint
  connect(endpoint = '') {
    return new Promise((resolve, reject) => {
      try {
        const wsUrl = this.getUrl(endpoint);
        const ws = new WebSocket(wsUrl);
        
        ws.onopen = () => {
          resolve(ws);
        };

        ws.onerror = (error) => {
          reject(error);
        };
      } catch (error) {
        reject(error);
      }
    });
  }
}

export default LogsConnect;
